<template class="content-notfound">
  <div class="div-center" style="padding-top:20px;">
    <div>
      <div class="notfound-text">Infelizmente não encontramos nada aqui. Por favor, verifique o endereço digitado.</div>
      <button @click="$router.push('/')" class="button-back"><i class="fas fa-hand-point-left"></i><span>  Voltar</span></button>
    </div>
    <div class="notfound">
      <img class="notfound" src="/img/erro404.png" alt="Not Found" title="Not Found">
    </div>
    
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'nao-encontrado',
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['user'])
  },
  async mounted () {
    if (!this.user) {
      this.$router.push('/')
      // this.$store.commit('redirect', '/usuario')
      this.$store.commit('showLogin', true)
      return false
    }
  },
  async beforeRouteUpdate (to, from, next) {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
@import "../_asset/scss/_variables.scss";

.content-notfound {
  display: flex;
  align-items: center;
  justify-content: center;
}
.div-center {
  text-align: center;
  margin-top:90px;
  height: 100vh;
}
.notfound-text {
  font-size: 18px;
  color: #8a888b;
  margin-bottom: 20px;
}
.button-back {
  color: #fff;
  border: none;
  border-radius: 100px;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 25px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}

.notfound {
  height: 150px;
  margin-top:70px;
}

//DESKTOP
@media screen and (min-width: $desktop-width2) {
.notfound {
  height: 400px;
  margin-top:70px;
}
}
</style>
